var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 44,
    viewBox: "0 0 22 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.21 40.89V42H9.41V40.89H11.168V35.832C11.168 35.632 11.174 35.426 11.186 35.214L9.938 36.258C9.866 36.314 9.794 36.35 9.722 36.366C9.654 36.378 9.588 36.378 9.524 36.366C9.464 36.354 9.41 36.334 9.362 36.306C9.314 36.274 9.278 36.24 9.254 36.204L8.786 35.562L11.432 33.312H12.65V40.89H14.21Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5H20C20.5523 5 21 5.44772 21 6V27.5C21 28.0523 20.5523 28.5 20 28.5H2C1.44772 28.5 1 28.0523 1 27.5V6C1 5.44772 1.44772 5 2 5H6M16 5V6.5C16 7.05228 15.5523 7.5 15 7.5H7C6.44772 7.5 6 7.05228 6 6.5V5M16 5V4.5C16 3.94772 15.5523 3.5 15 3.5H13.9684C13.6716 3.5 13.3901 3.36818 13.2002 3.14018L11.7682 1.42187C11.3684 0.942111 10.6316 0.942111 10.2318 1.42186L8.79985 3.14018C8.60985 3.36818 8.3284 3.5 8.03163 3.5H7C6.44772 3.5 6 3.94772 6 4.5V5M4 14H9.5M16 10.5H13C12.4477 10.5 12 10.9477 12 11.5V15C12 15.5523 12.4477 16 13 16H16.5C17.0523 16 17.5 15.5523 17.5 15V14M4 21H9.5M16.5 24H13C12.4477 24 12 23.5523 12 23V19C12 18.4477 12.4477 18 13 18H16.5C17.0523 18 17.5 18.4477 17.5 19V23C17.5 23.5523 17.0523 24 16.5 24Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13L15 14.5L17.5 11.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon1);
export default __webpack_public_path__ + "static/media/survey-icon-1.6755750e949b385127af2cc5a6746d21.svg";
export { ForwardRef as ReactComponent };